import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'automation',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'addAction' })
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}

export function useOnClickWait(props) {
  let submit = useDataSubmit({
    context: 'automation',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'addActionWait' })
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
